// removed by extract-text-webpack-plugin
module.exports = {"outlineBase":"PathSuggestions-outlineBase--1xUwG","isActive":"PathSuggestions-isActive--1x5QK","selected":"PathSuggestions-selected--3SVcm","underlineBase":"PathSuggestions-underlineBase--22_zX","lineBase":"PathSuggestions-lineBase--1iEr8","marching_ants":"PathSuggestions-marching_ants--hlHkh","outline":"PathSuggestions-outline--1yU23 PathSuggestions-outlineBase--1xUwG","underline":"PathSuggestions-underline--16sWV PathSuggestions-underlineBase--22_zX","line":"PathSuggestions-line--IcXma PathSuggestions-lineBase--1iEr8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Map/CreateSegment/PathSuggestion/PathSuggestions.scss
// module id = blEK
// module chunks = 4